export default __webpack_public_path__ + "static/media/snapchat.0cc075dd.svg";